var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    stroke: "black",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66952 10.5C9.55662 10.497 9.44794 10.4523 9.3611 10.3729L7.61977 9.06C7.39789 8.93717 7.22265 8.73216 7.125 8.48118V5.20588C7.125 4.81603 7.41268 4.5 7.76756 4.5C8.12243 4.5 8.41011 4.81603 8.41011 5.20588V8.1L9.83016 9.20118C10.1095 9.42991 10.2036 9.84316 10.0551 10.1894C9.99853 10.3715 9.8446 10.4955 9.66952 10.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.fc2e731c67150766c969cf766fb1df26.svg";
export { ForwardRef as ReactComponent };